export const COV_COLUMN_SUFFIX = 'CoV';
export const COV_COLUMN_OVERRIDE_MAP = new Map<string, string>([['currencyOfView', 'campaignBudgetCurrencyCode']]);
